import advtVideo from '../../assets/video/advtVideo.webm';

import styles from './AdvtVideo.module.css';

export const AdvtVideo = () => {
  return (
    <video autoPlay="autoplay" muted="muted" className={styles.advtVideo}>
      <source src={advtVideo} type="video/webm" />
    </video>
  );
};
